import { render, staticRenderFns } from "./ConversationWrapper.vue?vue&type=template&id=e9ab553c"
import script from "./ConversationWrapper.vue?vue&type=script&lang=js"
export * from "./ConversationWrapper.vue?vue&type=script&lang=js"
import style0 from "./ConversationWrapper.vue?vue&type=style&index=0&id=e9ab553c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports